import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { TransferCarrierListItem } from "@msuite/utils/types";
import { client } from "@/hono";

export function useTransferCarrier(transferCarrierId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["transfer-carrier", transferCarrierId],
		queryFn: async () => {
			const response = await client.stock["transfer-carriers"][":transferCarrierId"].$get({
				param: { transferCarrierId },
			});
			const data = await responseHandler(response);
			return data.transferCarrier as TransferCarrierListItem | null;
		},
	});

	/** Return */
	return { ...query, transferCarrier: query.data ?? null };
}
